import Ending from '../components/Ending';
import Onboarding from '../components/Onboarding';
import Player from '../components/Player';

interface GameProps {
  status: string;
  sessionToken: string;
  userToken: string;
  setGameStatus: Function;
  showAutoFlagReport?: boolean;
  finalMessage: GameFinalMessageT;
  customFields?: [];
}

export default function Game({
  status,
  setGameStatus,
  sessionToken,
  showAutoFlagReport,
  userToken,
  customFields,
  finalMessage,
}: GameProps) {
  if (status === 'on-boarding') {
    return (
      <Onboarding
        sessionToken={sessionToken}
        setGameStatus={setGameStatus}
        showAutoFlagReport={showAutoFlagReport}
        customFields={customFields}
      />
    );
  }

  if (status === 'playing') {
    return <Player setGameStatus={setGameStatus} sessionToken={sessionToken} />;
  }

  if (status === 'completed') {
    return <Ending userToken={userToken} finalMessage={finalMessage} />;
  }

  return null;
}
